import React from "react";

export const NoResults = () => <h1>No results</h1>
